import { render } from "./SocialBannerMini.vue?vue&type=template&id=9e701c1e"
import script from "./SocialBannerMini.vue?vue&type=script&lang=js"
export * from "./SocialBannerMini.vue?vue&type=script&lang=js"

import "./SocialBannerMini.vue?vue&type=style&index=0&id=9e701c1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__